<template>
  <div>
    <encashment-request-button
      v-if="!isManager"
      :year="year"
      :staff-id="staffId"
      :encashment-info="encashmentInfo"
      @fetch-encashment-requested="fetchList"
    />

    <div class="table-responsive">
      <table class="table table-striped">
        <thead>
          <tr>
            <th>Requested Date</th>
            <th>Days</th>
            <th>Status</th>
            <th v-if="!isManager" />
            <th v-if="isManager" />
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(encashment) in encashmentList"
            :key="encashment.id"
          >
            <td>{{ encashment.requested_date }}</td>
            <td>{{ encashment.days }}</td>
            <td>{{ getStatus(encashment) }}</td>
            <td v-if="!isManager">
              <button
                type="button"
                class="btn btn-danger"
                :disabled="encashment.is_rejected || submitting"
                @click="cancelRequest(encashment)"
              >
                Cancel
              </button>
            </td>
            <td v-if="isManager">
              <button
                type="button"
                class="btn btn-success"
                :disabled="encashment.is_approved || submitting "
                @click="approveRequest(encashment)"
              >
                Approve
              </button>
              <button
                type="button"
                class="btn btn-danger"
                :disabled="encashment.is_rejected || submitting"
                @click="rejectRequest(encashment)"
              >
                Reject
              </button>
              <span
                v-if="submitting"
                class="spinner"
              >
                <i class="fa fa-spinner fa-spin" />
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import EncashmentRequestButton from "./EncashmentRequestButton.vue";

export default {
    name: "EncashmentListTable",
    components: { EncashmentRequestButton },
    props: {
        staffId: {
            type: Number,
            required: true,
        },
        year: {
            type: Number,
            required: true,
        },
        isManager: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            submitting: false,
        };
    },
    computed: {
        ...mapGetters({
            encashmentList: "vacation/encashmentList",
            encashmentInfo: "vacation/encashmentInfo",
        }),
    },
    mounted() {
        this.fetchList();
    },
    methods: {
        getStatus(encashment) {
            if (encashment.is_approved) {
                return "Approved";
            } else if (encashment.is_rejected) {
                return "Rejected";
            }
            else {
                return "Pending";
            }
        },
        fetchList() {
            return this.fetchEncashmentList({ staffId: this.staffId, year: this.year });
        },
        async cancelRequest(encashment){
            try {
                if(confirm("Do you want to cancel this request?") === false) {
                    return;
                }
                this.submitting = true;
                await this.cancelEncashmentRequest({ id: encashment.id });
                alert("Encashment Request Cancelled");
                await this.fetchList();
            } catch (error) {
                alert("Error Occured");
                console.log(error);
            } finally {
                this.submitting = false;
            }
        },
        async approveRequest(encashment){
            try {
                if(confirm("Do you want to approve this request?") === false) {
                    return;
                }
                this.submitting = true;
                await this.managerUpdateRequest({ id: encashment.id, status: 'approved', type: 'encashment' });
                alert("Encashment Request Approved");
                await this.fetchList();
            } catch (error) {
                alert("Error Occured");
                console.log(error);
            } finally {
                this.submitting = false;
            }
        },
        async rejectRequest(encashment){
            try {
                if(confirm("Do you want to reject this request?") === false) {
                    return;
                }
                this.submitting = true;
                await this.managerUpdateRequest({ id: encashment.id, status: 'rejected', type: 'encashment' });
                alert("Encashment Request Rejected");
                await this.fetchList();
            } catch (error) {
                alert("Error Occured");
                console.log(error);
            } finally {
                this.submitting = false;
            }
        },
        ...mapActions({
            fetchEncashmentList: "vacation/getStaffEncashments",
            managerUpdateRequest: "vacation/managerUpdateRequest",
            cancelEncashmentRequest: "vacation/cancelEncashmentRequest",
        }),
    },
};
</script>

